export enum TourComponents {
  MyDocs = 'My Docs',
  DataCopilot = 'Data Copilot'
}
